<template>
  <div class="mx-3 mx-md-0">
    <div class="row mb-4">
      <div class="col-12">
        <h1 class="title text-uppercase font-weight-bold">Relatório</h1>
        <hr class="linha-amarela" />
      </div>
    </div>
    <div class="row align-items-end mb-5 justify-content-center">
      <div class="col-12 col-md-3 mb-2 mb-md-0">
        <label class="font-weight-bold" for="">Cidade</label>
        <v-select
          id="cadastroCidade"
          class="overflow-y"
          v-model="Fields.city"
          label="nome"
          :options="getCities"
          :reduce="(city) => city.id"
          placeholder="Selecione a cidade"
        >
          <div slot="no-options">Nenhuma cidade encontrda</div>
        </v-select>
        <p v-if="ErrorMessages.city !== null" class="error-message text-danger">
          {{ ErrorMessages.city }}
        </p>
      </div>
      <div class="col-12 col-md-3 mb-2 mb-md-0">
        <label class="font-weight-bold" for="">Data Inicial</label>
        <input
          type="date"
          class="form-control"
          v-model="Fields.startDate"
          pattern="\d{4}-\d{2}-\d{2}"
          required
          @change="ErrorMessages.startDate = null"
        />
        <p
          v-if="ErrorMessages.startDate !== null"
          class="error-message text-danger"
        >
          {{ ErrorMessages.startDate }}
        </p>
      </div>
      <div class="col-12 col-md-3 mb-2 mb-md-0">
        <label class="font-weight-bold" for="">Data Final</label>
        <input
          type="date"
          class="form-control"
          required
          v-model="Fields.endDate"
          @input="ErrorMessages.endDate = null"
          pattern="\d{4}-\d{2}-\d{2}"
        />
        <p
          v-if="ErrorMessages.endDate !== null"
          class="error-message text-danger"
        >
          {{ ErrorMessages.endDate }}
        </p>
      </div>
      <div class="col-12 col-md-3 mt-2 mt-md-0">
        <b-button variant="success" class="w-100" @click="search()">
          Pesquisar
          <i class="fas fa-search ml-2"></i>
        </b-button>
      </div>
    </div>
    <div class="row align-items-end mb-4" v-if="reportResult">
      <div class="col-md-12 col-md-12 col-lg-12 mb-2 mb-md-0">
        <h2 class="font-weight-bold d-block mb-0">Seus resultados</h2>
        <small v-if="Fields.startDate && Fields.endDate" class="mb-4">
          Entre {{ formatDate(Fields.startDate) }} e
          {{ formatDate(Fields.endDate) }}
        </small>
      </div>
      <b-row class="align-items-center mt-3 ml-1">
        <ReportCard
          :numberShopKeeper="reportResult.registered"
          icon="fas fa-check text-success"
          background="bg-success"
          border="border-success"
          text="Lojistas cadastrados"
          @click.native="
            reportResult.registered &&
              searchReportShopkeepers('aprovado', 'Lojistas cadastrados')
          "
        />
        <ReportCard
          :numberShopKeeper="reportResult.processing"
          icon="far fa-clock text-warning"
          background="bg-warning"
          border="border-warning"
          text="Lojistas em processamento"
          @click.native="
            reportResult.processing &&
              searchReportShopkeepers('processando', 'Lojistas processamento')
          "
        />
        <ReportCard
          :numberShopKeeper="reportResult.rejected"
          icon="fas fa-times c-danger text-danger"
          background="bg-danger"
          border="border-danger"
          text="Lojistas rejeitados"
          @click.native="
            reportResult.rejected &&
              searchReportShopkeepers('rejeitado', 'Lojistas rejeitados')
          "
        />
      </b-row>

      <ListShopkeepers
        :shopkeepers="reportShopkeepers"
        :modalTitle="reportShopkeepersModalTitle"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import makeToast from 'Mixins/makeToast';
import modal from 'Mixins/modal';
import ReportCard from './ReportCard.vue';
import CardTypes from '../../enums/Quote/CardTypes';
import ListShopkeepers from './ListShopkeepers.vue';

export default {
  name: 'Report',
  components: {
    ReportCard,
    ListShopkeepers,
  },
  mixins: [makeToast, modal],
  data() {
    return {
      CardTypes,
      Fields: {
        city: 0,
        startDate: null,
        endDate: null,
      },
      ErrorMessages: {
        city: null,
        startDate: null,
        endDate: null,
      },
      reportResult: null,
      reportShopkeepers: [],
      reportShopkeepersModalTitle: '',
    };
  },
  computed: {
    ...mapState(['cidades', 'dadosUsuario']),
    ...mapGetters('admin', ['getCities']),
    canShowShopkeeperList() {
      return this.reportShopkeepers.length > 0;
    },
  },
  created() {
    this.$store.dispatch('loadCidades');
    this.$store.dispatch('admin/getCities');
  },
  methods: {
    ...mapActions('affiliate', ['report', 'getReportShopkeepers']),
    search() {
      if (!this.validate()) {
        this.makeToast(
          'Oopss!',
          'Parece que há campos inválidos, preencha-os e tente novamente',
          'warning'
        );

        return;
      }

      this.$store.dispatch('startLoader');
      Object.assign(this.Fields, {
        affiliateId: this.dadosUsuario.informacoes.id,
      });

      this.report(this.Fields)
        .then((response) => {
          this.reportResult = response.data;
        })
        .catch((error) => {
          this.makeToast('Oopss!', error.response.data.message, 'danger');
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
    searchReportShopkeepers(paymentStatus, modalTitle) {
      this.$store.dispatch('startLoader');

      const filters = {
        affiliateId: this.dadosUsuario.informacoes.id,
        paymentStatus,
        startDate: this.Fields.startDate,
        endDate: this.Fields.endDate,
      };

      this.reportShopkeepers = [];

      this.getReportShopkeepers(filters)
        .then((response) => {
          this.reportShopkeepers = response.data.data;
          this.reportShopkeepersModalTitle = modalTitle;
          this.show('reportShopkeepers');
        })
        .catch((error) => {
          this.makeToast('Oopss!', error.response.data.message, 'danger');
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
    validate() {
      let valid = true;

      if (this.Fields.city && this.Fields.city !== 0 && !this.Fields.city) {
        this.ErrorMessages.city = 'Cidade inválida';
        valid = false;
      }

      if (
        this.Fields.startDate &&
        this.Fields.startDate !== '' &&
        !this.$validate.date(this.Fields.startDate)
      ) {
        this.ErrorMessages.startDate = 'Data inicial inválida';
        valid = false;
      }

      if (
        this.Fields.endDate &&
        this.Fields.endDate !== '' &&
        !this.$validate.date(this.Fields.endDate)
      ) {
        this.ErrorMessages.endDate = 'Data final inválida';
        valid = false;
      }

      return valid;
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
    },
  },
};
</script>

<style scoped>
.vs__selected .vs__dropdown-menu {
  position: absolute !important;
}
</style>
